<form class="actionbar">
  <div class="search-row">
    <div class="bar-wrapper">
      <i class="far fa-search"></i>
      <input class="search" type="text" [placeholder]="'SEARCH'| translate" [formControl]="searchControl">
    </div>
    <a class="sign-up" routerLink="../clients/new">{{'NEW_CLIENT' | translate}}</a>
  </div>
  <div class="filter-row">
    <app-slide-toggle size="small" labelText="{{'SHOW_ARCHIVED' | translate}}" labelPosition="left" [formControl]="showArchivedControl"></app-slide-toggle>
  </div>
</form>

<table class="client-table" [cellSpacing]="0">
  <thead>
    <tr>
      <th>{{'NAME' | translate}}</th>
      <th>{{'PHONE_NUMBER' | translate}}</th>
      <th>{{'CREATED_ON' | translate}}</th>
      <th *ngIf="showCoach">{{'COACH' | translate}}</th>
      <th>{{'PROGRESS' | translate}}</th>
      <th>{{'FANS' |translate}}</th>
      <th>{{'STATE' |translate}}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let user of users" (click)="onNavigate(user.id)">
      <td>{{ user.fullname }}</td>
      <td>{{ user.username }}</td>
      <td [innerText]="parseDate(user.created)"></td>
      <td *ngIf="showCoach">{{user.coach?.firstName}} {{user.coach?.lastName}}</td>
      <td>
        <span *ngIf="!user.courseStart" class="state-grey">{{'NOT_YET_LOGGEDIN' | translate}}</span>
        <span *ngIf="user.courseStart">{{convertDayToDisplay(user.day)}}</span>
      </td>
      <td>{{user.clientFanships.length}}</td>
      <td *ngIf="!user.paused && !user.archived" class="status status active"><i class="fa-solid fa-check" title="{{ 'ACTIVE' | translate }}"></i></td>
      <td *ngIf="user.paused && !user.archived" class="status status paused"><i class="fa-solid fa-pause" title="{{ 'PAUSED' | translate }}"></i></td>
      <td *ngIf="user.archived" class="status status archived"><i class="fa-solid fa-box-archive" title="{{ 'ARCHIVED' | translate }}"></i></td>
    </tr>
  </tbody>
</table>
